import type { BusinessTypeId } from "./business-types.js";

/** OWN-14: the six families the owner picks first (docs/design/verticals-v2.md §2). */
export const FAMILY_IDS = [
  "commerce",
  "food",
  "appointments",
  "travel",
  "real_estate",
  "general",
] as const;
export type FamilyId = (typeof FAMILY_IDS)[number];

/** Types inside each family, in display order. Every business type appears in exactly one family. */
export const FAMILY_TYPES: Record<FamilyId, readonly BusinessTypeId[]> = {
  commerce: ["online_store", "retail_shop"],
  food: ["restaurant"],
  appointments: ["clinic", "salon", "car_workshop", "services"],
  travel: ["travel"],
  real_estate: ["real_estate"],
  general: ["general"],
};

export function isFamilyId(v: unknown): v is FamilyId {
  return typeof v === "string" && (FAMILY_IDS as readonly string[]).includes(v);
}

export function typesOfFamily(family: FamilyId): readonly BusinessTypeId[] {
  return FAMILY_TYPES[family];
}

/** The family a type belongs to. */
export function familyOf(type: BusinessTypeId): FamilyId {
  return FAMILY_IDS.find((f) => FAMILY_TYPES[f].includes(type)) ?? "general";
}

/** The wizard asks for a specialty only when the family holds more than one type. */
export function needsSpecialty(family: FamilyId): boolean {
  return FAMILY_TYPES[family].length > 1;
}
